import styled from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/loadsmart-ui'

import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'

import { hasShipperInformation, type Proposal } from '../domain/Proposal'
import { getConfirmationContent } from '../presenters/rfpAwardedPresenter'

const ConfirmationImage = styled.img`
  width: 300px;
  height: 200px;
`

type AwardedProposalConfirmationHeaderProps = {
  awardedProposal: Proposal
}

export function AwardedProposalConfirmationHeader({
  awardedProposal,
}: AwardedProposalConfirmationHeaderProps): JSX.Element {
  const hasShipperInfo = hasShipperInformation(awardedProposal)
  const { imageSrc, title, subtitle, moreInformation } = getConfirmationContent(awardedProposal)
  const {
    rfp: { shipperEmail, shipperName, shipperPhone, shipperLogo },
  } = awardedProposal

  return (
    <Layout.Stack align="center" justify="center">
      <ConfirmationImage src={imageSrc} alt="" />
      <Text variant="heading-lg">{title}</Text>
      <Layout.Stack space="none" align="center">
        <Text>{subtitle}</Text>
        {hasShipperInfo && <Text>{moreInformation}</Text>}
      </Layout.Stack>
      {hasShipperInfo && (
        <ShipperInformation
          companyName={awardedProposal.shipperCompanyName}
          contactName={shipperName}
          email={shipperEmail}
          phone={shipperPhone}
          logo={shipperLogo}
          showContactInfo
        />
      )}
    </Layout.Stack>
  )
}
